import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, Ban, ShieldCheck, Flame } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const RULES = [
    {
        icon: CheckCircle2,
        color: "#16A34A",
        title: "Welcome",
        body: "SRT, R/T, Hellcat, Redeye, Demon, Super Stock, Scat Pack, TRX, RHO — all belong here.",
    },
    {
        icon: Ban,
        color: "#E10600",
        title: "No V6s. Ever.",
        body: "This isn't a Craigslist. If it's a base Charger, base Challenger, base 300, or a non-performance RAM — it doesn't belong.",
    },
    {
        icon: ShieldCheck,
        color: "#FFFFFF",
        title: "Real people, real cars",
        body: "Verified sellers, seller ratings, and moderated listings keep the community clean.",
    },
    {
        icon: Flame,
        color: "#E10600",
        title: "Show off",
        body: "Build your Garage, tag your car in threads, and let people see what you've done.",
    },
];

export default function Onboarding() {
    const { user } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-onyx-900 px-5 py-10">
            <div className="max-w-2xl mx-auto">
                <div className="flex justify-center mb-8">
                    <Logo size="lg" />
                </div>
                <motion.h1
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="headline text-4xl text-center"
                >
                    Welcome{user ? `, ${user.name.split(" ")[0]}` : ""}. Here's how this place runs.
                </motion.h1>

                <div className="mt-10 space-y-3">
                    {RULES.map((r, i) => (
                        <motion.div
                            key={r.title}
                            initial={{ opacity: 0, x: -12 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: i * 0.08 }}
                            className="surface rounded-md p-5 flex gap-4"
                        >
                            <div
                                className="w-11 h-11 rounded-md flex items-center justify-center shrink-0"
                                style={{ background: r.color === "#FFFFFF" ? "#1a1a1a" : r.color }}
                            >
                                <r.icon
                                    className="w-6 h-6"
                                    color={r.color === "#FFFFFF" ? "#FFFFFF" : "#FFFFFF"}
                                    strokeWidth={2.4}
                                />
                            </div>
                            <div>
                                <div className="headline text-xl">{r.title}</div>
                                <div className="text-sm text-onyx-500 mt-1">{r.body}</div>
                            </div>
                        </motion.div>
                    ))}
                </div>

                <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <Link
                        to="/marketplace"
                        data-testid="onboarding-start"
                        onClick={(e) => {
                            e.preventDefault();
                            navigate("/marketplace");
                        }}
                        className="btn-red rounded-sm py-3 text-center"
                    >
                        Enter the Marketplace
                    </Link>
                    <Link
                        to="/garage"
                        data-testid="onboarding-garage"
                        className="btn-ghost rounded-sm py-3 text-center font-bold uppercase tracking-widest text-sm"
                    >
                        Set up my Garage
                    </Link>
                </div>
            </div>
        </div>
    );
}
